import {
  dimensiondata_1_tetelek_group_dimension_1_2_3_row_w200,
  dimensiondata_2_termekek_group_dimension_1_2_column_expanded,
  year_column_expanded,
  KTOE_value_1_data_precision,
  TJ_value_2_data_precision,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const IEAreszletesConfig: PivotGridConfig = {
  showChart: false,
  treeHeaderLayout: true,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/IEAreszletes',
      select: ['date', 'dimension_1', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_group_dimension_1_2_3_row_w200,
      year_column_expanded,
      ...dimensiondata_2_termekek_group_dimension_1_2_column_expanded,
      KTOE_value_1_data_precision,
      TJ_value_2_data_precision,
      order_1,
      order_2
    ],
  },
};
